import { createFileRoute, Outlet } from '@tanstack/react-router';
import { SqlSyncImportRouteView } from '@/pages/workspaces/journeys/integrations/sql-sync/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * One import's detail: its chrome (name, description, tabs) around the active tab. The tabs are the
 * child routes — the run history at the index, then the query, relationships query and settings.
 *
 * No `appBundle`, for the same reason as the list: the URL has no `journeys` segment.
 */
function SqlSyncImportRoute() {
  const { type, sqlImportId } = Route.useParams();

  return (
    <LastWorkspaceResolver>
      <SqlSyncImportRouteView type={type} sqlImportId={sqlImportId}>
        <Outlet />
      </SqlSyncImportRouteView>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId',
)({
  component: SqlSyncImportRoute,
});
